export const RESTUX_IDENTIFIER = {
  questionEdition: 'questionEdition',
  createDocumentLayout: 'createDocumentLayout',
  createFileTemplate: 'createFileTemplate',
  me: 'me',
  addExistingQuestionToDocumentTemplate: 'addExistingQuestionToDocumentTemplate',
  addQuestionToDocumentTemplateSaga: 'addQuestionToDocumentTemplateSaga',
  createDocumentTemplateSaga: 'createDocumentTemplateSaga',
  updateDocumentTemplateSaga: 'updateDocumentTemplateSaga',
  manageDocumentTemplate: 'manageDocumentTemplate',
  medicalEventDocumentInstance: 'medicalEventDocumentInstance',
  medicalEventContent: 'medicalEventContent',
  medicalEventFiles: 'medicalEventFiles',
  updateMedicalEvent: 'updateMedicalEvent',
  pinMedicalEvent: 'pinMedicalEvent',
  documentInstanceEdition: 'documentInstanceEdition',
  fileEdition: 'fileEdition',
  deleteDocumentFromMedicalEvent: 'deleteDocumentFromMedicalEvent',
  updateDocumentTitleFromMedicalEvent: 'updateDocumentTitleFromMedicalEvent',
}
